import React, { useEffect } from "react";

const EMBED_URL = "https://embed.twitch.tv/embed/v1.js";

export interface Props {
  targetID: string;
  width: string;
  height: string;
  channel: string;
}

export function TwitchEmbed({ targetID, width, height, channel }: Props) {
  useEffect(() => {
    let embed;
    const script = document.createElement("script");
    script.setAttribute("src", EMBED_URL);
    script.addEventListener("load", () => {
      const newWindow: any = window;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      embed = new newWindow.Twitch.Embed(targetID, { width, height, channel });
    });
    document.body.appendChild(script);
  }, [channel, height, targetID, width]);

  return (
    <div>
      <div id={targetID}></div>
    </div>
  );
}
